module.exports = __webpack_public_path__ + "static/media/s64.00076745.jpg";